var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('GmapMap',{ref:"map",staticStyle:{"width":"100%","height":"100%"},attrs:{"center":_vm.map.center,"zoom":_vm.map.zoom,"options":_vm.map.options}},[(_vm.route)?[_vm._l((_vm.route.stops),function(stop,sindex){return _c('GmapMarker',{key:("s-" + sindex),attrs:{"title":stop.name,"position":stop.location,"icon":{
        url: _vm.getMarkerIconUrl(stop.type),
        scaledSize: {
          width: 35,
          height: 41,
          f: 'px',
          b: 'px'
        }
      }},on:{"click":function($event){return _vm.$emit('activateStopPopUp', stop.id)}}})}),_c('GmapPolyline',{attrs:{"path":_vm.route.path,"options":{
        strokeColor: _vm.colorLuminance(_vm.route.color, -0.5),
        strokeWeight: 7
      }}}),_c('GmapPolyline',{attrs:{"path":_vm.route.path,"options":{
        strokeColor: _vm.route.color,
        strokeWeight: 3
      }}}),_vm._l((_vm.cars),function(car,index){return _c('GmapMarker',{key:("c-" + index),attrs:{"position":car.location,"title":car.number,"icon":Object.assign({}, _vm.iconConfig,
        {strokeColor: _vm.route.color,
        rotation: car.course ? car.course : 0})},on:{"click":function($event){return _vm.$emit('activateCarPopUp', car.id)}}})})]:_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }